import { createContext } from "react";

import { Layout } from "@:constants";

export const SidebarContext = createContext({
  width: Layout.SidebarWidth - 20,
  collapseWidth: "80px",
  isCollapse: false,
  itemBackgroundColor: "#5c6677",
  itemTextColor: "#000000",
  itemContrastTextColor: "#ffffff",
  subHeaderTextColor: "#2b2b2b",
});
